import styled from 'styled-components';
export const GrantNotificationListContainer = styled.div `
  display: flex;
  flex-direction: column;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    gap: 16px;
  }
`;
export const GrantNotificationCardContainer = styled.div `
  display: flex;
  background: ${({ theme }) => theme.colors.white_1};
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};
  border: 1px solid ${({ theme }) => theme.colors.grey_1};
  border-radius: 4px;
  overflow: hidden;
  flex-direction: row;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    flex-direction: column;
  }
`;
export const GrantNotificationCardSection = styled.div `
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  padding: 8px;
  width: ${({ $widthPercentage }) => $widthPercentage}%;
  ${({ $isLast, theme }) => !$isLast && `border-right: 1px solid ${theme.colors.grey_4};`}
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    width: 100%;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 12px 16px;
    border-right: none;
    border-top: 1px solid ${({ theme }) => theme.colors.grey_5};
    &:first-of-type {
      border-top: none;
    }
    ${({ $isAction }) => $isAction && 'display: none;'}
    &:last-child {
      align-items: flex-end;
    }
  }
`;
export const GrantNotificationCardHeader = styled.div `
  overflow: hidden;
  display: flex;
  flex-direction: row;
  gap: 32px;
  padding: 16px;
  align-items: center;
  width: ${({ $widthPercentage }) => $widthPercentage}%;
  ${({ theme }) => `border-right: 1px solid ${theme.colors.grey_4};`}
  justify-content: space-between;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    width: 100%;
    gap: 12px;
    padding: 12px 16px;
    border-right: none;
    border-bottom: none;
    align-items: flex-start;
    position: relative;
  }
`;
export const GrantNotificationCardHeaderContent = styled.div `
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  flex: 1;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    gap: 8px;
    padding-right: 48px;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    > :first-child {
      align-self: center;
    }
  }
`;
export const GrantNotificationCardHeaderInfo = styled.div `
  display: block;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    gap: 6px;
  }
`;
export const GrantNotificationCardAction = styled.div `
  width: 40px;
  height: 40px;
  border-radius: 4px;
  display: flex;
  background: ${({ theme }) => theme.colors.grey_5};
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.purple_5};
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    width: 32px;
    height: 32px;
  }
`;
export const GrantNotificationListHeaderContainer = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey_4};
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: none;
  }
`;
export const GrantNotificationListHeaderSection = styled.div `
  display: flex;
  padding: 4px 16px;
  width: ${({ $widthPercentage }) => $widthPercentage}%;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: 0;
  }
`;
export const GrantNotificationMobileLabel = styled.div `
  display: none;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: block;
    font-size: 11px;
    line-height: 14px;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    color: ${({ theme }) => theme.colors.grey_2};
    margin-bottom: 2px;
  }
`;
export const GrantNotificationMobileOnly = styled.div `
  display: none;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: block;
    position: absolute;
    top: 12px;
    right: 16px;
  }
`;
export const GrantNotificationEmptySection = styled.div `
  display: flex;
  background: ${({ theme }) => theme.colors.white_1};
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};
  border: 1px solid ${({ theme }) => theme.colors.grey_1};
  border-radius: 4px;
  overflow: hidden;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px 32px;
`;
